import { RequireAuth } from "@allergy123/auth-client/react";
import { createBrowserRouter, Outlet } from "react-router";
import { ClearTimersOnSignOut } from "./encounter/RunningTimers";
import { IdleSignOut } from "./idle";
import { AuthCallbackPage, NoAccessPage, SignedOutPage } from "./pages/auth";
import { CalendarPage } from "./pages/Calendar";
import { EncounterPage } from "./pages/Encounter";
import { EncountersPage } from "./pages/Encounters";
import { PatientPage } from "./pages/Patient";
import { PatientsPage } from "./pages/Patients";
import { ReportsPage } from "./pages/Reports";
import { SettingsPage } from "./pages/Settings";
import { SuppliesPage } from "./pages/Supplies";
import { TodayPage } from "./pages/Today";
import { SessionProvider } from "./session";
import { ClinicShell } from "./shell";

/**
 * The clinic app (docs/clinic-rebuild/api-v2.md). Every screen is behind sign-in and a resolved practice
 * session; the API makes every authorization decision on every request, so the browser only avoids rendering
 * what the caller cannot use. Record ids in URLs are opaque uuids; no patient data travels in a URL. A signed-in tab
 * signs itself out after a stretch without input (idle.tsx). A sign-out removes every signed-in screen, and the tab's
 * running timers, before it waits for anything.
 */
export const router = createBrowserRouter([
  { path: "/auth/callback", Component: AuthCallbackPage },
  { path: "/auth/signed-out", Component: SignedOutPage },
  { path: "/no-access", Component: NoAccessPage },
  {
    path: "/",
    element: (
      <>
        <ClearTimersOnSignOut />
        <RequireAuth fallback={<p className="p-6 text-ink-secondary">Signing you in…</p>} signingOut={<p className="p-6 text-ink-secondary" role="status">Signing you out…</p>}>
          <IdleSignOut>
            <SessionProvider>
              <ClinicShell>
                <Outlet />
              </ClinicShell>
            </SessionProvider>
          </IdleSignOut>
        </RequireAuth>
      </>
    ),
    children: [
      { index: true, Component: TodayPage },
      { path: "calendar", Component: CalendarPage },
      { path: "patients", Component: PatientsPage },
      { path: "encounters", Component: EncountersPage },
      { path: "reports", Component: ReportsPage },
      { path: "supplies", Component: SuppliesPage },
      { path: "settings", Component: SettingsPage },
      { path: "patients/:id", Component: PatientPage },
      { path: "encounters/:id", Component: EncounterPage },
    ],
  },
]);
